export default __webpack_public_path__ + "static/media/down.icon.bde23aae.svg";